// ../../Public/not-found-data.js
import { ASSETS } from './assets-data.js';

export const getNotFoundData = (language) => {
    const data = {
        en: {
            seo: {
                title: "404 - Page Not Found | Tropical Marine Construction",
                description: "The page you are looking for doesn't exist. Return to Tropical Marine Construction for dock construction and boat lift services in Cape Coral, FL."
            },
            image: ASSETS.TROPICAL_MARINE_LOGO || '',
            title: "404 NOT FOUND",
            subtitle: "LOOKS LIKE THIS PAGE GOT AWAY.",
            description: "We couldn't find the page you were looking for. Let us help you navigate back to the right place.",
            buttonText: "BACK TO HOMEPAGE",
        },
        he: {
            seo: {
                title: "404 - Page Not Found | Tropical Marine Construction",
                description: "The page you are looking for doesn't exist. Return to Tropical Marine Construction for dock construction and boat lift services in Cape Coral, FL."
            },
            image: ASSETS.TROPICAL_MARINE_LOGO || '',
            title: "404 NOT FOUND",
            subtitle: "LOOKS LIKE THIS PAGE GOT AWAY.",
            description: "We couldn't find the page you were looking for. Let us help you navigate back to the right place.",
            buttonText: "BACK TO HOMEPAGE",
        }
    };
    return data[language] || data.en;
};
